import { text } from "framer-motion/client";

export const banners = [
  {
    id: 1,
    bg: '/banners/bg-01.jpg',
    car: '/banners/car-01.png',
    ghost: 'RMMOTORS',
    titleSmall: 'Seu próximo carro está',
    titleBig: 'AQUI!',
    cta: 'Estoque',
    ctaLink: '/estoque',
    direction: 'right',
    accentColor: 'red',
  },
  {
    id: 2,
    bg: '/banners/bg-02.jpg',
    car: '/banners/car-02.png',
    ghost: 'NOVO',
    titleSmall: 'Carros com preço e',
    titleBig: 'QUALIDADE',
    cta: 'Estoque',
    ctaLink: '/estoque',
    direction: 'left',
    accentColor: 'blue',
  },
  {
    id: 2,
    bg: '/banners/bg-02.jpg',
    car: '/banners/car-03.png',
    ghost: 'CONTATO',
    titleSmall: 'Ficou interessado?',
    titleBig: 'FALE CONOSCO',
    cta: 'Contato',
    ctaLink: '/contato',
    direction: 'left',
    accentColor: 'green',
  },
];

